import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { dialogSizes } from '../../constants/dialogSizesConstant';
import { joinClassNames } from '../../services/elementHelperService';

interface ConfirmationDialogProps {
	mediaTitle?: string;
	title: string;
	icon?: React.ReactNode;
	message: React.ReactNode;
	descriptionAsHtml?: string;
	open?: boolean;
	okButtonText?: string;
	cancelButtonText?: string;
	noCancelButton?: boolean;
	callback?: (_result: { ok: boolean }) => void;
	t?: any;
}

const ConfirmationDialog = ({
	mediaTitle,
	title,
	icon,
	message,
	open: openProp = true,
	okButtonText,
	cancelButtonText,
	noCancelButton,
	callback,
	t,
}: ConfirmationDialogProps) => {
	const [open, setOpen] = useState(openProp);

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Dialog
			id="ConfirmationDialog"
			fullWidth={true}
			maxWidth={dialogSizes.SMALL as any}
			open={open}
			className="confirmationPopup"
		>
			<DialogTitle className="dialogTitle" disableTypography>
				{icon}
				<Typography variant="h6">{title}</Typography>
				<IconButton
					onClick={() => {
						handleClose();
						callback?.({ ok: false });
					}}
				>
					<Close />
				</IconButton>
			</DialogTitle>

			<DialogContent>
				<DialogContentText className="dialogContentWrapper">
					<span className="dialogContentText">
						{message}
					</span>
					{mediaTitle && <div className="itemsList">
						<span className="dialogContentText dialogContentText--bold">
							{mediaTitle}
						</span>
					</div>}
				</DialogContentText>
			</DialogContent>

			<DialogActions className={joinClassNames("dialogActions", noCancelButton ? "dialogActions--end" : "")}>
				{noCancelButton !== true && <Button
					variant="outlined"
					color="primary"
					style={{ whiteSpace: 'nowrap' }}
					onClick={() => {
						handleClose();
						callback?.({ ok: false });
					}}
				>
					{cancelButtonText || t?.('COMMON_BACK')}
				</Button>}
				<Button
					variant="contained"
					color="primary"
					style={{ whiteSpace: 'nowrap' }}
					onClick={() => {
						handleClose();
						callback?.({ ok: true });
					}}
				>
					{okButtonText || t?.('COMMON_DELETE')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

ConfirmationDialog.propTypes = {
	mediaTitle: PropTypes.string,
	title: PropTypes.string.isRequired,
	icon: PropTypes.any,
	message: PropTypes.any.isRequired,
	descriptionAsHtml: PropTypes.string,
	open: PropTypes.bool.isRequired,
	okButtonText: PropTypes.string.isRequired,
	cancelButtonText: PropTypes.string.isRequired,
	callback: PropTypes.func,
	t: PropTypes.func,
};

ConfirmationDialog.defaultProps = {
	open: true,
	title: 'Confirmation',
	message: 'Are you sure to perform this action?',
	okButtonText: 'Yes',
	cancelButtonText: 'Go back',
};

export default ConfirmationDialog;
